import { Modal } from "@arco-design/web-react";

export type LoginAction = "login" | "register";

interface OpenLoginDialogOptions {
  onSelect?: (action: LoginAction) => void;
}

export async function openLoginDialog(options?: OpenLoginDialogOptions) {
  const { LoginRegisterModal } = await import("@/dialog/LoginRegisterModal");
  const close = () => Modal.destroyAll();
  Modal.confirm({
    title: null,
    icon: null,
    closable: true,
    footer: null,
    className: "login-register-arco-modal",
    wrapClassName: "login-register-arco-modal-wrap",
    style: { width: "fit-content", maxWidth: "calc(100vw - 32px)", borderRadius: "9px", padding: 0 },
    content: (
      <LoginRegisterModal
        onClose={close}
        onSelect={(action) => {
          options?.onSelect?.(action);
          close();
        }}
      />
    ),
  });
}

interface OpenPaySubscribeDialogOptions {
  type: "subscribe" | "points";
  plan: any;
}

export async function openPaySubscribeDialog({ type, plan }: OpenPaySubscribeDialogOptions) {
  const { default: PaySubscribe } = await import("@/dialog/pay-subscribe");
  const close = () => Modal.destroyAll();
  Modal.confirm({
    title: null,
    icon: null,
    closable: true,
    footer: null,
    style: { width: "fit-content", maxWidth: "calc(100vw - 32px)", borderRadius: "26px" },
    content: <PaySubscribe onClose={close} type={type} plan={plan} />,
  });
}

export async function openPointsRechargeDialog() {
  const { default: PointsRecharge } = await import("@/dialog/points-recharge");
  Modal.confirm({
    title: null,
    icon: null,
    closable: true,
    footer: null,
    style: { width: "fit-content", maxWidth: "calc(100vw - 32px)", borderRadius: "26px" },
    content: <PointsRecharge />,
  });
}

export async function openPointsDetailDialog() {
  const { default: PointsDetailModal } = await import("@/dialog/points-detail-modal");
  Modal.confirm({
    title: null,
    icon: null,
    closable: true,
    footer: null,
    style: { width: "fit-content", maxWidth: "calc(100vw - 32px)", borderRadius: "26px", padding: 0 },
    content: <PointsDetailModal />,
  });
}
